<template>
  <v-list>
    <v-list-group prepend-icon="fas fa-search-location" value="true">
      <template v-slot:activator>
        <v-list-tile>
          <v-list-tile-title>Quick Search</v-list-tile-title>
        </v-list-tile>
      </template>
      <v-list-group no-action sub-group>
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Cities</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list-tile
          v-for="(city, i) in cities"
          :key="i"
          :to="city.path"
        >
          <v-list-tile-action>
            <v-icon small>{{ city.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ city.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>
      <v-list-group no-action sub-group>
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Communities</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list-tile
          v-for="(community, i) in communities"
          :key="i"
          :to="community.path"
        >
          <v-list-tile-action>
            <v-icon small>{{ community.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ community.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>
      <v-list-group no-action sub-group>
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Zip Codes</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list-tile
          v-for="(zipcode, i) in zipcodes"
          :key="i"
          :to="zipcode.path"
        >
          <v-list-tile-action>
            <v-icon small>{{ zipcode.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ zipcode.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>
    </v-list-group>
  </v-list>
</template>

<script>
import { communities, zipcodes, cities } from '../json/links.json';

export default {
  name: 'TheSidenavLinks',
  created() {
    this.communities = communities;
    this.zipcodes = zipcodes;
    this.cities = cities;
  },
};
</script>
